import angular from 'angular';
import CategoriesFilter from './categories-filter.component';
import categoriesInputFilter from './categories-input-filter/categories-input-filter';
import CategoriesSliderFilterModule from './categories-slider-filter/categories-slider-filter';

let CategoriesFilterModule = angular.module('catalog.categoriesFilter', [
  categoriesInputFilter.name,
  CategoriesSliderFilterModule.name
])
  .component('categoriesFilter', CategoriesFilter);

export default CategoriesFilterModule;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/catalog/categories-filter/categories-filter.js
 **/